<template>
  <section>
    <Feature :title="$t('QUOTATION_DATA_DETAIL')" :iconClass="'fa-pencil-square-o'">
      <FormRow :fieldNameArr="[$t('GROUP_KEY')]">
        <Input v-model="groupId" slot="a" disabled />
      </FormRow>
      <Collapse v-if="editable" :accordion="true">
        <Panel>
          {{ $t("LABEL_TEXT_BATCH_EDIT") }}
          <Form label-position="right" :label-width="120" :inline="true" slot="content">
            <FormItem :label="$t('UNIT_PRICE')">
              <Input type="number" v-model="batchPrice" />
            </FormItem>
            <FormItem :label="$t('VALID_FROM')">
              <DatePicker type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" v-model="batchValidFrom"></DatePicker>
            </FormItem>
            <FormItem :label="$t('VALID_TO')">
              <DatePicker type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')" v-model="batchValidTo"></DatePicker>
            </FormItem>
            <FormItem>
              <Button type="primary" style="width: 250px" @click="showBatchUpdateScalePriceModal">{{ $t("UPDATE") }} {{ $t("SCALE_PRICE") }}</Button>
            </FormItem>
            <FormItem>
              <Button type="primary" style="width: 250px" @click="showBatchQuotationFileUploadModal">{{ $t("QUOTATION_FILE_UPLOAD") }}</Button>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="batchSave">{{ $t('BUTTON_TEXT_SAVE') }}</Button>
            </FormItem>
          </Form>
        </Panel>
      </Collapse>
      <FormRowTwo v-if="cpcToVendorAttachments.length > 0" :fieldNameArr="[$t('REJECT_ATTACHMENT')]">
      </FormRowTwo>
      <FormRowTwo v-if="cpcToVendorAttachments.length > 0" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
      <br/>
      <Table :columns="columnList" :data="quotationList">
        <template slot-scope="{ row, index }" slot="unitPrice">
          <Input v-if="editable" v-model="quotationList[index].unitPrice" />
          <span v-else v-text="quotationList[index].unitPrice"></span>
        </template>
        <template slot-scope="{ row, index }" slot="validFromAndValidTo">
          <DatePicker v-if="editable" v-model="quotationList[index].validFrom" type="date" format="yyyy-MM-dd" placeholder="Select Date"></DatePicker>
          <DatePicker v-if="editable" v-model="quotationList[index].validTo" type="date" format="yyyy-MM-dd" placeholder="Select Date"></DatePicker>
          <div v-else>
            <span v-text="parseDate(quotationList[index].validFrom)"></span>
            <br/>
            <span v-text="parseDate(quotationList[index].validTo)"></span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="scalePrice">
          <Icon :type="row.quotationScalePriceList && row.quotationScalePriceList.length > 0 ? 'md-reorder' : ''" size="28" class="text-delta-blue" @click="showScalePriceModal(index)" />
        </template>
      </Table>
      <Row v-if="quotationList.length > 0" type="flex" justify="space-between">
        <Col type="flex" justify="start">
          {{ $t("COMMON_TEXT_FROM") }} {{ pageObj.page * pageObj.pageSize - (pageObj.pageSize - 1) }} {{ $t("COMMON_TEXT_TO") }}
          <span v-if="pageObj.totalCount < pageObj.page * pageObj.pageSize">{{ pageObj.totalCount }}</span>
          <span v-else> {{ pageObj.page * pageObj.pageSize }}</span>
          {{ $t("COMMON_TEXT_OF") }} {{ pageObj.totalCount }} {{ $t("COMMON_TEXT_ENTRIES") }}
        </Col>
        <Col type="flex" justify="end">
          <Page :total="pageObj.totalCount" :page-size="pageObj.pageSize" :prev-text="$t('COMMON_TEXT_PREV')" :next-text="$t('COMMON_TEXT_NEXT')" @on-change="changePage" @on-page-size-change="changePageSize" show-sizer :page-size-opts="[20, 50, 100]">
          </Page>
        </Col>
      </Row>
      <ButtonRow>
        <Button v-if="editable" type="primary" @click="save" slot="0">{{ $t("SAVE") }}</Button>
        <Button v-if="editable" type="success" @click="submit" slot="1">{{ $t('SUBMIT') }}</Button>
        <Button v-if="editable" type="primary" @click="Upload" slot="2">{{ $t('UPLOAD') }}</Button>
        <Button type="primary" @click="Back" slot="3">{{ $t('BACK') }}</Button>
      </ButtonRow>
    </Feature>

    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="scalePricesModal" :title="$t('SCALE_PRICE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="scalePriceColumnList" :data="scalePrices" :max-height="550">
          <template slot-scope="{ row, index }" slot="scaleQuantity">
            <Input v-if="editable" v-model="scalePrices[index].scaleQuantity" />
            <span v-else v-text="scalePrices[index].scaleQuantity"></span>
          </template>
          <template slot-scope="{ row, index }" slot="scalePrice">
            <Input v-if="editable" v-model="scalePrices[index].scalePrice" />
            <span v-else v-text="scalePrices[index].scalePrice"></span>
          </template>
        </Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="batchUpdateScalePriceModal" :title="$t('SCALE_PRICE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="batchScalePriceColumnList" :data="batchScalePrices" :max-height="550">
          <template slot-scope="{ row, index }" slot="scaleQuantity">
            <Input v-model="batchScalePrices[index].scaleQuantity" />
          </template>
          <template slot-scope="{ row, index }" slot="scalePrice">
            <Input v-model="batchScalePrices[index].scalePrice" />
          </template>
        </Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="batchQuotationFileUploadModal" :title="$t('APPROVE') + ' ' + $t('REFERENCE_FILE')">
      <FormRow :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file === null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadSupplierQuotationFiles">{{ $t("CLICK_UPLOAD") }}</Button>
      </FormRow>
      <Table width="600" border :columns="fileSchemaList" :data="supplierQuotationFiles">
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          <Button type="error" shape="circle" icon="md-close-circle" @click="deleteSupplierQuotationFiles(row)"></Button>
        </template>
      </Table>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="900" sticky :draggable="true" v-model="uploadModel"
      :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow
        :fieldNameArr="['(STEP2) Quotation File sUpload (File Size < 5MB)', batchAttachmentFile == null ? '' : batchAttachmentFile.name]">
        <Upload slot="a" :before-upload="handleBatchAttachmentUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="batchAttachmentFile !== null" slot="b" @click="uploadBatchAttachement">{{
          $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
      <FormRow v-if="batchAttachmentUuid" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="batchAttachmentFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
      <FormRow :fieldNameArr="['Batch Excel File Upload', batchFile == null ? '' : batchFile.name]">
        <Upload slot="a" :before-upload="handleBatchUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="batchFile !== null" slot="b" @click="uploadBatch">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="errorMsgModal"
      :title="$t('QUOTATION')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="errorMsgColumnList" :data="errorMessages" max-height="800"></Table>
      </div>
    </Modal>
  </section>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertError } from "@/util/alert"
import { CheckNumber, CheckFloat, CheckCurrency, Translate, DownloadFile } from "@/util/common"
import { FileSchemaList } from "@/util/tableTitle"
import { utils } from "xlsx"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "CpcDetailMaintain",
  props: {
    status: {
      type: String,
      default: "Waiting"
    }
  },
  components: {
    FormRowTwo
  },
  inject: ["reload"],
  data() {
    return {
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20,
        "sort": ["partNo,asc"]
      },
      batchPrice: "",
      batchValidFrom: "",
      batchValidTo: "",
      batchUpdateScalePriceModal: false,
      batchScalePrices: [{
        item: 2,
        scalePrice: "",
        scaleQuantity: ""
      }, {
        item: 3,
        scalePrice: "",
        scaleQuantity: ""
      }, {
        item: 4,
        scalePrice: "",
        scaleQuantity: ""
      }, {
        item: 5,
        scalePrice: "",
        scaleQuantity: ""
      }],
      batchQuotationFileUploadModal: false,
      file: null,
      quotationList: [],
      scalePricesModal: false,
      scalePrices: [],
      supplierQuotationFileModal: false,
      uploadModel: false,
      supplierQuotationFiles: [],
      cpcToVendorAttachments: [],
      errorMsgModal: false,
      errorMessages: [],
      batchAttachmentUuid: "",
      batchFile: null,
      batchAttachmentFile: null,
      batchAttachmentFiles: [],
      fileSchemaList: FileSchemaList(this),
      errorMsgColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('{PART_NO}');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Part No",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('YOUR_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Unit Price",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_QUANTITY') + " 2"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Quantity 2",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_PRICE') + " 2"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Price 2",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_QUANTITY') + " 3"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Quantity 3",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_PRICE') + " 3"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Price 3",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_QUANTITY') + " 4"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Quantity 4",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_PRICE') + " 4"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Price 4",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_QUANTITY') + " 5"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Quantity 5",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_PRICE') + " 5"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Price 5",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RAW_MATERIAL_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Raw Material Type",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RAW_MATERIAL_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Raw Material Price",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ERROR_MESSAGE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "errorMessage",
          render: (h, params) => {
            let html = "<lable>" + params.row.errorMessage + "</lable>";
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          width: 400,
          align: "center",
        },
      ]
    }
  },
  created() {
    const vueInstance = this;
    if (vueInstance.groupId) {
      vueInstance.$quotationHttp
        .get("/supplier/rfq/" + vueInstance.groupId + "/quotationFiles")
        .then(response => {
          if (response.data) {
            vueInstance.supplierQuotationFiles = response.data;
          }
        });
      vueInstance.$quotationHttp
        .get("/supplier/rfq/" + vueInstance.groupId + "/rejectFiles")
        .then(response => {
          if (response.data) {
            vueInstance.cpcToVendorAttachments = response.data;
          }
        });
      vueInstance.search(true);
    } else {
      vueInstance.$router.push({
        name: "SUPPLIER_MAINTAIN"
      });
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getSupplierGroupId", "getModalSize"]),
    ...mapActions(["toggleLoading"]),
    search(init) {
      const vueInstance = this;
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20,
          "sort": ["partNo,asc"]
        };
      }
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .get("/supplier/rfq/" + vueInstance.groupId + "/quotationDetails?page=" + vueInstance.pageObj.page + "&size=" + vueInstance.pageObj.pageSize + (vueInstance.pageObj.sort === undefined || Array.isArray(vueInstance.pageObj.sort) === false || vueInstance.pageObj.sort.length === 0 ? "" : "&sort=" + vueInstance.pageObj.sort.join("&sort=")))
        .then(response => {
          vueInstance.quotationList = []
          vueInstance.quotationList = response.data.content;
          vueInstance.quotationList.forEach(quotation => {
            quotation.validFrom = quotation.validFrom === undefined || quotation.validFrom === null ? new Date() : new Date(quotation.validFrom);
            quotation.validTo = quotation.validTo === undefined || quotation.validTo === null ? vueInstance.defaultValidTo : new Date(quotation.validTo);
            [2, 3, 4, 5].forEach(item => {
              let quotationScalePrice = quotation.quotationScalePriceList.find(scalePrice => item === scalePrice.item);
              if (quotationScalePrice === undefined) {
                quotation.quotationScalePriceList.push({
                  item: item,
                  scaleQuantity: "",
                  scalePrice: ""
                });
              }
            });
          });
          vueInstance.pageObj = {
            "page": response.data.number + 1,
            "totalPage": response.data.totalPages,
            "totalCount": response.data.totalElements,
            "pageSize": response.data.size,
            "sort": ["partNo,asc"]
          };
          if (vueInstance.quotationList.length === 0) {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => h('span', [Translate("COMMON_TEXT_NOTHING")])
            });
          }
        })
        .catch(() => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    changePageSize(newPageSize) {
      const vueInstance = this;
      vueInstance.pageObj.pageSize = newPageSize;
      vueInstance.pageObj.page = 0;
      vueInstance.search(false);
    },
    changePage(page) {
      const vueInstance = this;
      vueInstance.pageObj.page = page - 1
      vueInstance.search(false);
    },
    Back() {
      this.$router.push({ name: 'SUPPLIER_MAINTAIN' })
    },
    showBatchUpdateScalePriceModal() {
      this.batchUpdateScalePriceModal = true;
    },
    valid(partNo, price, currency, scalePriceList) {
      let vueInstance = this
      let errorMessage = vueInstance.$validSupplierQuotationPrice(vueInstance, "PartNo(" + partNo + ") -", price, currency)

      let lastScaleQuantity = 1
      let lastScalePrice = 0
      scalePriceList.forEach(element => {
        if (!element.scaleQuantity) {
          if (element.scalePrice) {
            errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('PLEASE_KEY_IN_QUANTITY') + " <br>"
          }
        } else {
          if (element.scaleQuantity && !CheckNumber(element.scaleQuantity)) {
            errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('QUANTITY_MUST_BE_NUMBER') + " <br>"
          } else {
            if (lastScaleQuantity === "" || lastScaleQuantity === undefined) {
              errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('PERIOUS_QUANTITY_IS_EMPTY') + " <br>"
            } else if (Number(element.scaleQuantity) <= Number(lastScaleQuantity)) {
              errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('QUANTITY_IS_LESS_THAN_PREVIOUS') + " <br>"
            }
          }
        }
        lastScaleQuantity = element.scaleQuantity

        if (!element.scalePrice) {
          if (element.scaleQuantity) {
            errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('PLEASE_KEY_IN_PRICE') + " <br>"
          }
        } else {
          if (element.scalePrice && !CheckFloat(element.scalePrice)) {
            errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('PRICE_MUST_BE_NUMBER') + " <br>"
          } else {
            if (CheckCurrency(element.scalePrice)) {
              if (element.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
                errorMessage = errorMessage + "PartNo(" + partNo + ") -" + this.$t('PRICE_IS_MORE_THAN_FOUR_DIGITS') + " <br>"
              }
            } else {
              if (element.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
                errorMessage = errorMessage + "PartNo(" + partNo + ") -" + this.$t('PRICE_IS_MORE_THAN_SIX_DIGITS') + " <br>"
              }
            }

            if (lastScalePrice === "" || lastScalePrice === undefined) {
              errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('PERIOUS_PRICE_IS_EMPTY') + " <br>"
            } else if (Number(element.scalePrice) >= Number(lastScalePrice)) {
              if (element.item == "2") {
                if (Number(element.scalePrice) >= Number(price)) {
                  errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('PRICE_IS_MORE_THAN_PREVIOUS') + " <br>"
                }
              } else {
                errorMessage = errorMessage + "PartNo(" + partNo + ") -" + "Item " + element.item + ": " + this.$t('PRICE_IS_MORE_THAN_PREVIOUS') + " <br>"
              }
            }
          }
        }
        lastScalePrice = element.scalePrice
      })
      return errorMessage
    },
    batchSave() {
      const vueInstance = this;
      if (vueInstance.batchPrice !== undefined && vueInstance.batchPrice != null && vueInstance.batchPrice !== "") {
        if (Number(vueInstance.batchPrice) <= 0) {
          AlertInfo(vueInstance, vueInstance.$t("PRICE_MUST_MORE_THAN_ZERO"))
            .then(() => {});
          return;
        }
        if (CheckCurrency(vueInstance.quotationList[0].currency)) {
          if (vueInstance.batchPrice.toString().split("").reverse().join("").indexOf(".") > 4) {
            AlertInfo(vueInstance, vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"))
              .then(() => {});
            return;
          }
        } else {
          if (vueInstance.batchPrice.toString().split("").reverse().join("").indexOf(".") > 6) {
            AlertInfo(vueInstance, vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"))
              .then(() => {});
            return;
          }
        }
      }
      let errorMessageArray = [];
      let batchScalePrice2 = vueInstance.batchScalePrices.find(scalePrice => scalePrice.item === 2);
      if (batchScalePrice2.scaleQuantity && !batchScalePrice2.scalePrice) {
        errorMessageArray.push("Item: 2 " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
      }
      if (!batchScalePrice2.scaleQuantity && batchScalePrice2.scalePrice) {
        errorMessageArray.push("Item: 2 " + vueInstance.$t("PLEASE_KEY_IN_QUANTITY"));
      }
      if (batchScalePrice2.scaleQuantity && batchScalePrice2.scalePrice) {
        if (Number(batchScalePrice2.scalePrice) >= Number(vueInstance.batchPrice)) {
          errorMessageArray.push("Item: 2 " + vueInstance.$t("PRICE_IS_MORE_THAN_PREVIOUS"));
        }
        if (CheckCurrency(vueInstance.quotationList[0].currency)) {
          if (batchScalePrice2.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
            errorMessageArray.push("Item: 2 " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
          }
        } else {
          if (batchScalePrice2.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
            errorMessageArray.push("Item: 2 " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
          }
        }
        let batchScalePrice3 = vueInstance.batchScalePrices.find(scalePrice => scalePrice.item === 3);
        if (batchScalePrice3.scaleQuantity && !batchScalePrice3.scalePrice) {
          errorMessageArray.push("Item: 3 " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
        }
        if (!batchScalePrice3.scaleQuantity && batchScalePrice3.scalePrice) {
          errorMessageArray.push("Item: 3 " + vueInstance.$t("PLEASE_KEY_IN_QUANTITY"));
        }
        if (batchScalePrice3.scaleQuantity && batchScalePrice3.scalePrice) {
          if (Number(batchScalePrice3.scaleQuantity) <= Number(batchScalePrice2.scaleQuantity)) {
            errorMessageArray.push("Item: 3 " + vueInstance.$t("QUANTITY_IS_LESS_THAN_PREVIOUS"));
          }
          if (Number(batchScalePrice3.scalePrice) >= Number(batchScalePrice2.scalePrice)) {
            errorMessageArray.push("Item: 3 " + vueInstance.$t("PRICE_IS_MORE_THAN_PREVIOUS"));
          }
          if (CheckCurrency(vueInstance.quotationList[0].currency)) {
            if (batchScalePrice3.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
              errorMessageArray.push("Item: 3 " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
            }
          } else {
            if (batchScalePrice3.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
              errorMessageArray.push("Item: 3 " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
            }
          }
          let batchScalePrice4 = vueInstance.batchScalePrices.find(scalePrice => scalePrice.item === 4);
          if (batchScalePrice4.scaleQuantity && !batchScalePrice4.scalePrice) {
            errorMessageArray.push("Item: 4 " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
          }
          if (!batchScalePrice4.scaleQuantity && batchScalePrice4.scalePrice) {
            errorMessageArray.push("Item: 4 " + vueInstance.$t("PLEASE_KEY_IN_QUANTITY"));
          }
          if (batchScalePrice4.scaleQuantity && batchScalePrice4.scalePrice) {
            if (Number(batchScalePrice4.scaleQuantity) <= Number(batchScalePrice3.scaleQuantity)) {
              errorMessageArray.push("Item: 4 " + vueInstance.$t("QUANTITY_IS_LESS_THAN_PREVIOUS"));
            }
            if (Number(batchScalePrice4.scalePrice) >= Number(batchScalePrice3.scalePrice)) {
              errorMessageArray.push("Item: 4 " + vueInstance.$t("PRICE_IS_MORE_THAN_PREVIOUS"));
            }
            if (CheckCurrency(vueInstance.quotationList[0].currency)) {
              if (batchScalePrice4.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
                errorMessageArray.push("Item: 4 " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
              }
            } else {
              if (batchScalePrice4.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
                errorMessageArray.push("Item: 4 " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
              }
            }
            let batchScalePrice5 = vueInstance.batchScalePrices.find(scalePrice => scalePrice.item === 5);
            if (batchScalePrice5.scaleQuantity && !batchScalePrice5.scalePrice) {
              errorMessageArray.push("Item: 5 " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
            }
            if (!batchScalePrice5.scaleQuantity && batchScalePrice5.scalePrice) {
              errorMessageArray.push("Item: 5 " + vueInstance.$t("PLEASE_KEY_IN_QUANTITY"));
            }
            if (batchScalePrice5.scaleQuantity && batchScalePrice5.scalePrice) {
              if (Number(batchScalePrice5.scaleQuantity) <= Number(batchScalePrice4.scaleQuantity)) {
                errorMessageArray.push("Item: 5 " + vueInstance.$t("QUANTITY_IS_LESS_THAN_PREVIOUS"));
              }
              if (Number(batchScalePrice5.scalePrice) >= Number(batchScalePrice4.scalePrice)) {
                errorMessageArray.push("Item: 5 " + vueInstance.$t("PRICE_IS_MORE_THAN_PREVIOUS"));
              }
              if (CheckCurrency(vueInstance.quotationList[0].currency)) {
                if (batchScalePrice5.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
                  errorMessageArray.push("Item: 5 " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
                }
              } else {
                if (batchScalePrice5.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
                  errorMessageArray.push("Item: 5 " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
                }
              }
            }
          }
        }
      }
      if (errorMessageArray.length > 0) {
        AlertInfo(vueInstance, errorMessageArray.join("<br/>"))
          .then(() => {});
        return;
      }
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .post("/supplier/rfq/" + vueInstance.groupId + "/batch/save", {
          groupId: vueInstance.groupId,
          price: vueInstance.batchPrice,
          scalePrice2: vueInstance.batchScalePrices.find(scalePrice => scalePrice.item === 2 && scalePrice.scaleQuantity && scalePrice.scalePrice),
          scalePrice3: vueInstance.batchScalePrices.find(scalePrice => scalePrice.item === 3 && scalePrice.scaleQuantity && scalePrice.scalePrice),
          scalePrice4: vueInstance.batchScalePrices.find(scalePrice => scalePrice.item === 4 && scalePrice.scaleQuantity && scalePrice.scalePrice),
          scalePrice5: vueInstance.batchScalePrices.find(scalePrice => scalePrice.item === 5 && scalePrice.scaleQuantity && scalePrice.scalePrice),
          validFrom: vueInstance.parseDate(vueInstance.batchValidFrom),
          validTo: vueInstance.parseDate(vueInstance.batchValidTo),
          quotationSupplierAttachments: vueInstance.supplierQuotationFiles
        })
        .then(response => {
          AlertInfo(vueInstance, vueInstance.$t("COMMON_MESSAGE_SUCCESS"))
            .then(() => {
              vueInstance.reload();
            });
        })
        .catch(error => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    save() {
      const vueInstance = this;
      let errorMessageArray = [];
      vueInstance.quotationList.forEach(quotation => {
        if (!quotation.unitPrice) {
          errorMessageArray.push("PartNo: " + quotation.partNo + " " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
        } else {
          if (Number(quotation.unitPrice) <= 0) {
            errorMessageArray.push("PartNo: " + quotation.partNo + " " + vueInstance.$t("PRICE_MUST_MORE_THAN_ZERO"));
          } else {
            if (CheckCurrency(quotation.currency)) {
              if (vueInstance.batchPrice.toString().split("").reverse().join("").indexOf(".") > 4) {
                errorMessageArray.push("PartNo: " + quotation.partNo + " " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
              }
            } else {
              if (vueInstance.batchPrice.toString().split("").reverse().join("").indexOf(".") > 6) {
                errorMessageArray.push("PartNo: " + quotation.partNo + " " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
              }
            }
          }
        }
        if (!quotation.validFrom) {
          errorMessageArray.push("PartNo: " + quotation.partNo + " [Valid From] " + vueInstance.$t("CAN_NOT_EMPTY"));
        }
        if (!quotation.validTo) {
          errorMessageArray.push("PartNo: " + quotation.partNo + " [Valid To] " + vueInstance.$t("CAN_NOT_EMPTY"));
        }
        let scalePrice2 = quotation.quotationScalePriceList.find(scalePrice => scalePrice.item === 2);
        if (scalePrice2.scaleQuantity && !scalePrice2.scalePrice) {
          errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 2 " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
        }
        if (!scalePrice2.scaleQuantity && scalePrice2.scalePrice) {
          errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 2 " + vueInstance.$t("PLEASE_KEY_IN_QUANTITY"));
        }
        if (scalePrice2.scaleQuantity && scalePrice2.scalePrice) {
          if (Number(scalePrice2.scalePrice) >= Number(quotation.unitPrice)) {
            errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 2 " + vueInstance.$t("PRICE_IS_MORE_THAN_PREVIOUS"));
          }
          if (CheckCurrency(quotation.currency)) {
            if (scalePrice2.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
              errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 2 " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
            }
          } else {
            if (scalePrice2.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
              errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 2 " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
            }
          }
          let scalePrice3 = quotation.quotationScalePriceList.find(scalePrice => scalePrice.item === 3);
          if (scalePrice3.scaleQuantity && !scalePrice3.scalePrice) {
            errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 3 " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
          }
          if (!scalePrice3.scaleQuantity && scalePrice3.scalePrice) {
            errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 3 " + vueInstance.$t("PLEASE_KEY_IN_QUANTITY"));
          }
          if (scalePrice3.scaleQuantity && scalePrice3.scalePrice) {
            if (Number(scalePrice3.scaleQuantity) <= Number(scalePrice2.scaleQuantity)) {
              errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 3 " + vueInstance.$t("QUANTITY_IS_LESS_THAN_PREVIOUS"));
            }
            if (Number(scalePrice3.scalePrice) >= Number(scalePrice2.scalePrice)) {
              errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 3 " + vueInstance.$t("PRICE_IS_MORE_THAN_PREVIOUS"));
            }
            if (CheckCurrency(quotation.currency)) {
              if (scalePrice3.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
                errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 3 " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
              }
            } else {
              if (scalePrice3.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
                errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 3 " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
              }
            }
            let scalePrice4 = quotation.quotationScalePriceList.find(scalePrice => scalePrice.item === 4);
            if (scalePrice4.scaleQuantity && !scalePrice4.scalePrice) {
              errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 4 " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
            }
            if (!scalePrice4.scaleQuantity && scalePrice4.scalePrice) {
              errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 4 " + vueInstance.$t("PLEASE_KEY_IN_QUANTITY"));
            }
            if (scalePrice4.scaleQuantity && scalePrice4.scalePrice) {
              if (Number(scalePrice4.scaleQuantity) <= Number(scalePrice3.scaleQuantity)) {
                errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 4 " + vueInstance.$t("QUANTITY_IS_LESS_THAN_PREVIOUS"));
              }
              if (Number(scalePrice4.scalePrice) >= Number(scalePrice3.scalePrice)) {
                errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 4 " + vueInstance.$t("PRICE_IS_MORE_THAN_PREVIOUS"));
              }
              if (CheckCurrency(quotation.currency)) {
                if (scalePrice4.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
                  errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 4 " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
                }
              } else {
                if (scalePrice4.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
                  errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 4 " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
                }
              }
              let scalePrice5 = quotation.quotationScalePriceList.find(scalePrice => scalePrice.item === 5);
              if (scalePrice5.scaleQuantity && !scalePrice5.scalePrice) {
                errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 5 " + vueInstance.$t("PLEASE_KEY_IN_PRICE"));
              }
              if (!scalePrice5.scaleQuantity && scalePrice5.scalePrice) {
                errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 5 " + vueInstance.$t("PLEASE_KEY_IN_QUANTITY"));
              }
              if (scalePrice5.scaleQuantity && scalePrice5.scalePrice) {
                if (Number(scalePrice5.scaleQuantity) <= Number(scalePrice4.scaleQuantity)) {
                  errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 5 " + vueInstance.$t("QUANTITY_IS_LESS_THAN_PREVIOUS"));
                }
                if (Number(scalePrice5.scalePrice) >= Number(scalePrice4.scalePrice)) {
                  errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 5 " + vueInstance.$t("PRICE_IS_MORE_THAN_PREVIOUS"));
                }
                if (CheckCurrency(quotation.currency)) {
                  if (scalePrice5.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
                    errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 5 " + vueInstance.$t("PRICE_IS_MORE_THAN_FOUR_DIGITS"));
                  }
                } else {
                  if (scalePrice5.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
                    errorMessageArray.push("PartNo: " + quotation.partNo + " [Scale Price] Item: 5 " + vueInstance.$t("PRICE_IS_MORE_THAN_SIX_DIGITS"));
                  }
                }
              }
            }
          }
        }
      });
      if (errorMessageArray.length > 0) {
        AlertInfo(vueInstance, errorMessageArray.join("<br/>"))
          .then(() => {});
        return;
      }
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .post("/supplier/rfq/save", {
          quotationRequestList: vueInstance.quotationList.map(quotation => {
            return {
              formNo: quotation.formNo,
              price: quotation.unitPrice,
              validFrom: vueInstance.parseDate(quotation.validFrom),
              validTo: vueInstance.parseDate(quotation.validTo),
              scalePrice2: quotation.quotationScalePriceList.find(scalePrice => scalePrice.item === 2 && scalePrice.scaleQuantity && scalePrice.scalePrice),
              scalePrice3: quotation.quotationScalePriceList.find(scalePrice => scalePrice.item === 3 && scalePrice.scaleQuantity && scalePrice.scalePrice),
              scalePrice4: quotation.quotationScalePriceList.find(scalePrice => scalePrice.item === 4 && scalePrice.scaleQuantity && scalePrice.scalePrice),
              scalePrice5: quotation.quotationScalePriceList.find(scalePrice => scalePrice.item === 5 && scalePrice.scaleQuantity && scalePrice.scalePrice)
            };
          })
        })
        .then(response => {
          AlertInfo(vueInstance, vueInstance.$t("COMMON_MESSAGE_SUCCESS"))
            .then(() => {});
        })
        .catch(() => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    submit() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .post("/supplier/rfq/submit", {
          groupId: vueInstance.groupId
        })
        .then(response => {
          AlertInfo(vueInstance, response.data.content[0].status)
            .then(() => {
              vueInstance.$router.push({
                name: "SUPPLIER_MAINTAIN"
              });
            });
        })
        .catch(error => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    Upload() {
      this.uploadModel = true
    },
    downloadSample() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .get("/supplier/rfq/batch/download?groupId=" + vueInstance.getSupplierGroupId(), {
          responseType: "blob"
        })
        .then(response => {
          if (response.data) {
            DownloadFile(new Blob([response.data]), response.headers["content-disposition"].split("\"")[1])
          }
        })
        .catch((error) => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    handleBatchAttachmentUpload(file) {
      this.batchAttachmentFile = file;
      return false;
    },
    uploadBatchAttachement() {
      let fd = new FormData()
      fd.append('file', this.batchAttachmentFile)
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=quotation", fd)
        .then((response) => {
          this.batchAttachmentFiles = []
          this.batchAttachmentFiles.push(response.data)
          this.batchAttachmentUuid = response.data.uuid
          this.batchAttachmentFile = null
          this.toggleLoading(false)
        })
        .catch(() => {
          this.toggleLoading(false)
        })
    },
    handleBatchUpload(file) {
      this.batchFile = file;
      return false;
    },
    async uploadBatch() {
      const vueInstance = this

      let excelData = {
        title: null,
        body: null
      }
      const workBook = await this.$readerWorkBookFromLocal(this.batchFile),
        workSheet = workBook.Sheets[workBook.SheetNames[0]],
        content = utils.sheet_to_json(workSheet, { raw: false })
      excelData.title = Object.keys(content[0])
      excelData.body = content
      vueInstance.errorMessages = []
      excelData.body.forEach(quotation => {
        let scalePriceList = []
        for (let i = 2; i < 6; i++) {
          scalePriceList.push({
            item: i,
            scalePrice: quotation['Scale Price ' + i] ? quotation['Scale Price ' + i] : "",
            scaleQuantity: quotation['Scale Quantity ' + i] ? quotation['Scale Quantity ' + i] : ""
          })
        }
        console.log(quotation['Unit Price'])
        console.log(scalePriceList)
        quotation.errorMessage = vueInstance.valid(quotation['Part No'], quotation['Unit Price'], quotation['Currency'], scalePriceList)
        if (quotation.errorMessage) {
          vueInstance.errorMessages.push(quotation)
        }
      })

      let errorMessage = ""
      if (vueInstance.batchAttachmentUuid == "") {
        errorMessage = errorMessage + "Please Upload Quotation File"
      }

      if (vueInstance.errorMessages.length > 0) {
        vueInstance.batchFile = null
        vueInstance.errorMsgModal = true
      } else if (errorMessage) {
        vueInstance.batchFile = null
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        let fd = new FormData()
        fd.append('file', this.batchFile)
        let formNos = []
        vueInstance.quotationList.forEach(q => {
          formNos.push(q.formNo)
        })
        fd.append('formNoList', formNos)
        fd.append('fileUuid', vueInstance.batchAttachmentUuid)
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/rfq/batch-upload", fd)
          .then((response) => {
            vueInstance.uploadModel = false
            AlertInfo(vueInstance, response.data.content[0].status)
              .then(() => {
                vueInstance.$router.push({
                  name: "SUPPLIER_MAINTAIN"
                });
              });
          })
          .catch((error) => {
            console.error(error);
            AlertError(vueInstance, error)
              .then(() => {});
          })
          .finally(() => {
            vueInstance.batchFile = null;
            vueInstance.toggleLoading(false);
          });
      }
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    showBatchQuotationFileUploadModal() {
      this.batchQuotationFileUploadModal = true;
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.id)
    },
    uploadSupplierQuotationFiles() {
      let fd = new FormData()
      fd.append('file', this.file)
      fd.append('description', "quotaion attachement")
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=rfqQuoation", fd)
        .then((response) => {
          this.toggleLoading(false)
          if (!this.supplierQuotationFiles) {
            this.supplierQuotationFiles = []
          }
          this.supplierQuotationFiles.push(response.data)
          this.file = null
          this.toggleLoading(false)
        })
        .catch(() => { })
    },
    deleteSupplierQuotationFiles(row) {
      const vueInstance = this;
      vueInstance.supplierQuotationFiles.splice(row._index, 1);
    },
    showScalePriceModal(index) {
      const vueInstance = this;
      vueInstance.scalePrices = vueInstance.quotationList[index].quotationScalePriceList;
      vueInstance.scalePricesModal = true;
    },
    parseDate(date) {
      if (!(date instanceof Date) || isNaN(date)) {
        return null
      }
      return date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, "0") + "-" + date.getDate().toString().padStart(2, "0");
    }
  },
  computed: {
    groupId: {
      get() {
        return this.getSupplierGroupId();
      }
    },
    editable: {
      get() {
        return this.status === "Waiting";
      }
    },
    defaultValidTo: {
      get() {
        let today = new Date();
        return new Date(today.getFullYear() + (today.getMonth() + 1 > 9 ? 1 : 0), 11, 31);
      }
    },
    modalSize() {
      return this.getModalSize()
    },
    columnList() {
      return [{
        title: this.$t("FORM_NO"),
        align: "center",
        width: 200,
        key: "formNo"
      }, {
        title: this.$t("PART_NO"),
        align: "center",
        width: 200,
        key: "partNo"
      }, {
        title: this.$t("PART_NO_DESCRIPTION"),
        align: "center",
        width: 200,
        key: "partDescription"
      }, {
        title: this.$t("VENDOR_PN"),
        align: "center",
        width: 200,
        key: "vendorPartNo"
      }, {
        title: this.$t("PLANT"),
        align: "center",
        width: 100,
        key: "plant"
      }, {
        title: this.$t("CURRENCY"),
        align: "center",
        width: 100,
        key: "currency"
      }, {
        title: this.$t("UNIT_PRICE"),
        align: "center",
        width: 80,
        slot: "unitPrice"
      }, {
        renderHeader: (h, params) => h("div", {}, [this.$t("VALID_FROM"), h("br"), this.$t("VALID_TO")]),
        align: "center",
        width: 150,
        slot: "validFromAndValidTo"
      }, {
        renderHeader: (h, params) => h("div", {}, [this.$t("SCALE"), h("br"), this.$t("PRICE")]),
        align: "center",
        width: 100,
        slot: "scalePrice"
      }];
    },
    scalePriceColumnList() {
      return [{
        title: this.$t("ITEM"),
        align: "center",
        width: 80,
        key: "item"
      }, {
        renderHeader: (h, params) => h("div", {}, [this.$t("SCALE"), h("br"), this.$t("QUANTITY")]),
        align: "center",
        slot: "scaleQuantity"
      }, {
        renderHeader: (h, params) => h("div", {}, [this.$t("SCALE"), h("br"), this.$t("PRICE")]),
        align: "center",
        slot: "scalePrice"
      }];
    },
    batchScalePriceColumnList() {
      return [{
        title: this.$t("ITEM"),
        align: "center",
        width: 80,
        key: "item"
      }, {
        renderHeader: (h, params) => h("div", {}, [this.$t("SCALE"), h("br"), this.$t("QUANTITY")]),
        align: "center",
        slot: "scaleQuantity"
      }, {
        renderHeader: (h, params) => h("div", {}, [this.$t("SCALE"), h("br"), this.$t("PRICE")]),
        align: "center",
        slot: "scalePrice"
      }];
    }
  }
}

function buildCriteria(vueInstance) {
  let result = []
  vueInstance.quotationList.forEach(quotation => {
    result.push({
      'price': quotation.price,
      'scalePrices': quotation.scalePrices,
      'validFrom': quotation.validFrom,
      'validTo': quotation.validTo,
      'uuid': quotation.uuid,
      'supplierQuotationFiles': vueInstance.supplierQuotationFiles
    })
  })
  return result
}
</script>

<style scoped></style>
